import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { getDefaultCalendarView, dateRangeByView } from '../../dashboard/booking/calendarView/Calendar';
import Calendar from '../../dashboard/booking/IndividualConsultationCalendar';
import BookingOptions from '../../dashboard/booking/IndividualConsultationBookingOptions';
import TimetableSearchForm from './TimetableSearchForm';
import queryString from 'query-string';
import { withNamespaces } from 'react-i18next';
import { updateSelectedCenter } from '../../dashboard/actions';
import {
	loadIndividualConsultationSchedule, INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST, INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS, INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE
} from '../../dashboard/common/actions';
import {
	storeIndividualConsultationSearchQuery, selectCenter, selectConsultationDate, unselectLesson, selectChild,
	startIndividualConsultationEnrolment
} from '../../dashboard/booking/actions';
import moment from 'moment';
import { getActiveLanguage } from '../../languages/reducer';

class IndividualConsultationsTimetable extends Component {
	constructor(props) {
		super(props);

		this.handleCitySelect = this.handleCitySelect.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);

		this.handleCalendarNavigate = this.handleCalendarNavigate.bind(this);
		this.handleConsultationDateSelect = this.handleConsultationDateSelect.bind(this);
		this.handleLessonUnselect = this.handleLessonUnselect.bind(this);

		this.handleBookingOptionsConfirm = this.handleBookingOptionsConfirm.bind(this);
	}

	componentDidMount() {
		this.reloadData(this.props);
		this.props.storeIndividualConsultationSearchQuery(this.props.location.search);
		document.title = this.props.t('FO_Document_Title', { systemName: this.props.franchisor.systemName });
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.searchParams.centerId && !nextProps.searchParams.city && nextProps.parentCenter && nextProps.centers.length > 0) {
			// init with parent's selected center if parent is logged in
			this.handleCenterSelect(nextProps.parentCenter.id, true, nextProps.centers);
		}

		if (nextProps.searchParams.centerId && nextProps.centers.length > 0 && !nextProps.searchParams.date) {
			// if date is not selected, init calendar with the first date according to selected center's schedule (individualConsultationStartDate)
			this.handleCenterSelect(nextProps.searchParams.centerId, true, nextProps.centers);
		}

		// all search params are in the query string, reload schedule when query string changes
		if (this.props.location.search !== nextProps.location.search) {
			this.props.storeIndividualConsultationSearchQuery(nextProps.location.search);

			const currentQueryParams = queryString.parse(this.props.location.search);
			const nextQueryParams = queryString.parse(nextProps.location.search);

			if (currentQueryParams.centerId !== nextQueryParams.centerId ||
				currentQueryParams.date !== nextQueryParams.date) {
				this.reloadData(nextProps);
			}

			// reload booking options when consultation date is selected
			if (currentQueryParams.consultationDate !== nextQueryParams.consultationDate) {
				this.reloadBookingOptions(nextProps);
			}
		}
	}

	reloadData(props) {
		const { searchParams: { centerId, date }, loadIndividualConsultationSchedule } = props;
		if (centerId) {
			if (date) {
				const { from, to } = dateRangeByView(getDefaultCalendarView(true), date);
				loadIndividualConsultationSchedule(centerId, null, from, to);
			}
		}
	}

	reloadBookingOptions(props) {
		const { searchParams: { centerId, consultationDate }, selectConsultationDate, selectCenter, unselectLesson } = props;

		if (consultationDate) {
			selectConsultationDate(consultationDate);
			selectCenter(centerId);
		} else {
			unselectLesson();
		}
	}

	updateSearchParams(newParam, replaceHistory) {
		const { searchParams, location, history } = this.props;

		const newSearchParams = Object.assign(searchParams, newParam);

		const newPath = {
			pathname: location.pathname,
			search: queryString.stringify(newSearchParams)
		};

		if (replaceHistory) {
			history.replace(newPath);
		} else {
			history.push(newPath);
		}
	}

	handleCitySelect(city) {
		this.updateSearchParams({ city, centerId: null });
		this.handleLessonUnselect(true);

		const cityCenters = city ? this.props.centers.filter(x => x.city === city) : this.props.centers;
		if (cityCenters.length === 1) {
			this.handleCenterSelect(cityCenters[0].id, true);
		}
	}

	handleCenterSelect(centerId, replaceHistory, allCenters) {
		const selectedCenterId = Number(centerId);
		if (selectedCenterId) {
			const centers = allCenters || this.props.centers;
			const selectedCenter = centers.find(x => x.id === selectedCenterId);
			this.updateSearchParams({ city: selectedCenter && selectedCenter.city, centerId: selectedCenterId }, replaceHistory);

			if (this.props.parent.id > 0) { // update parent's center if parent is logged in
				this.props.updateSelectedCenter(selectedCenterId, this.props.history, false);
			}

			this.handleDateSelect(this.getCalendarInitialDateForCenter(selectedCenter), true);
			this.handleLessonUnselect(true);
		}
	}

	getCalendarInitialDateForCenter(center) {
		return center && center.individualConsultationStartDate ? new Date(center.individualConsultationStartDate) : new Date();
	}

	handleDateSelect(date, replaceHistory) {
		this.updateSearchParams({ date: moment(date).format('YYYY-MM-DD') }, replaceHistory);
	}

	handleCalendarNavigate(date) {
		this.handleDateSelect(date);
	}

	handleConsultationDateSelect(date) {
		this.updateSearchParams({ consultationDate: date });
	}

	handleLessonUnselect(replaceHistory) {
		this.updateSearchParams({ consultationDate: null }, replaceHistory);
	}

	handleBookingOptionsConfirm() {
		const { selectedCenter, franchisor } = this.props;
		this.props.startIndividualConsultationEnrolment({
			center: selectedCenter,
			consultationType: 'Assessment',
			currency: franchisor.currency,
			total: selectedCenter.individualConsultationFirstPrice
		});
		this.props.history.push('/register', { from: '/individual-consultation/booking/child' });
	}

	render() {
		const { franchisor, cities, centers, selectedCenter } = this.props;
		const { city, date } = this.props.searchParams;

		const selectedCity = city;
		const selectedDate = date && new Date(date);
		const initialDate = this.getCalendarInitialDateForCenter(selectedCenter);

		return <div className='timetable-wrapper'>
			<Row className={this.props.bookingOptions.date ? 'hidden-xs' : ''}>
				<Col md={12}>
					<TimetableSearchForm
						cities={cities}
						centers={centers}
						selectedCity={selectedCity}
						selectedCenter={selectedCenter}
						onSelectCity={this.handleCitySelect}
						onSelectCenter={this.handleCenterSelect}
						franchisorDisplayName={franchisor.displayName}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={12} style={{ marginTop: '30px' }}>
					<div className={this.props.bookingOptions.date ? 'calendar-container hidden-xs' : 'calendar-container'}>
						<Calendar
							date={selectedDate}
							initialDate={initialDate}
							center={selectedCenter}
							schedule={this.props.individualConsultationSchedule}
							enableUserTimeZone={franchisor.enableUserTimeZone}
							onNavigate={this.handleCalendarNavigate}
							onSelectConsultationDate={this.handleConsultationDateSelect}
							calendarBlock={INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST}
							calendarUnblock={[INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS, INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE]}
						/>
					</div>
					<div className={!this.props.bookingOptions.date ? (this.props.parent.id > 0 ? 'booking-options-container hidden-xs' : 'hidden') : 'booking-options-container'} >
						<BookingOptions
							children={this.props.children}
							center={selectedCenter}
							enableUserTimeZone={franchisor.enableUserTimeZone}
							bookingOptions={this.props.bookingOptions}
							onCancel={this.handleLessonUnselect}
							onSelectChild={this.props.selectChild}
							onConfirm={this.handleBookingOptionsConfirm}
							enableCurrencyConversion={franchisor.enableCurrencyConversion}
							currentCurrency={this.props.currentCurrency}
							franchisorCurrency={franchisor.currency}
						/>
					</div>
					<div className='clearfix' />
				</Col>
			</Row>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { entities: { centers, individualConsultationSchedule }, configuration: { franchisor }, parent } = state;
	const {
		date,
		errorMessage,
		selectedChildId
	} = state.booking;

	const queryParams = queryString.parse(ownProps.location.search);
	const selectedCenterId = queryParams.centerId ? Number(queryParams.centerId) : null;
	const selectedCenter = selectedCenterId && centers[selectedCenterId]

	const parentCenterId = parent.centerId;
	const parentCenter = parentCenterId ? centers[parentCenterId] : null;

	const scheduleFilter = (selectedCenterId && state.filters.individualConsultationScheduleByChildAndCenter[`${selectedChildId && selectedChildId > 0 ? selectedChildId : 'all'}-${selectedCenterId}`]) || { ids: [], loading: false };
	const individualConsultationScheduleForSelectedChildAndCenter = scheduleFilter.ids.map(id => individualConsultationSchedule[id]);

	const isValidBookingDate = individualConsultationScheduleForSelectedChildAndCenter.some(x => x.start === date);

	const allChildren = state.parent.children;
	const centersWithIndividualConsultations = Object.keys(centers).map(key => centers[key]).filter(c => c.isIndividualConsultation);
	const activeLanguage = getActiveLanguage(state.configuration.language);

	return {
		franchisor,
		currentCurrency: activeLanguage && activeLanguage.currencyCode,
		parentCenter,
		searchParams: {
			city: queryParams.city,
			centerId: selectedCenterId,
			date: queryParams.date,
			consultationDate: queryParams.consultationDate
		},
		parent,
		centers: centersWithIndividualConsultations.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1),
		selectedCenter,
		cities: [...new Set(centersWithIndividualConsultations.map(center => center.city))],	// distinct list of cities with centers
		individualConsultationSchedule: individualConsultationScheduleForSelectedChildAndCenter,
		children: allChildren,
		bookingOptions: {
			date: isValidBookingDate ? date : null,
			errorMessage,
			selectedChildId
		}
	};
};

export default connect(mapStateToProps, {
	loadIndividualConsultationSchedule,
	selectCenter,
	selectConsultationDate,
	unselectLesson,
	selectChild,
	updateSelectedCenter,
	storeIndividualConsultationSearchQuery,
	startIndividualConsultationEnrolment
})(withNamespaces()(IndividualConsultationsTimetable));